import Component from './TreeCellMeasurer.component';

export default Component;
